import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import TelerikDataTable from "../../../../CommonComponents/TelerikDataTable/indexV2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
import useSortedColumns from "../../../../utils/useSortedColumns";
import AdvanceSearch from "../../../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../../../ErrorBoundry";
import visileColumns from "./visibleColumns";
import { Radio } from "@mui/material";
import EligibilityTable from "../Eligibility/EligibilityTable";
import CustomizerContext from "../../../../_helper/Customizer";

function ApplicantsListByEligibility() {
    const id = "ApplicantsListByEligibility";
    const { singleEligibilityList, EligibilityTableShow } = useContext(CustomizerContext);
    const ANNOUNCEMENT_ID_Value = useMemo(()=>{
        const {ANNOUNCEMENT_ID} = EligibilityTableShow
        if(ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim()
        return ""
    },[EligibilityTableShow])

    const ELIGIBILITY_ID_Value = useMemo(()=>{
        const {eligibility_id} = singleEligibilityList
        if(eligibility_id) return eligibility_id.trim()
        return ""
    },[singleEligibilityList])
    const dispatch = useDispatch();
    const history = useNavigate();
    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
        return {
          results: searchResult.results,
          rowCount: searchResult.rowCount,
        };
      }, [searchResultsV2, id]);
    console.log(results,rowCount,'jobData1221')
    const { userData } = useAuth();
    const [expandedSearchResult, setexpandedSearchResult] = useState(false);
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([
        { field: "evaluation_rating", dir: "desc" },
    ]);
    const [searchParams, setSearchParams] = useState([{columnName:"announcement_id",value:ANNOUNCEMENT_ID_Value,operator:"=",dataType:"varchar(50)",logicOperator:"AND"},{columnName:"eligibility_list",value:ELIGIBILITY_ID_Value,operator:"=",dataType:"varchar(500)",logicOperator:"AND"}]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
    const [deleteData, setDeleteData] = useState(null);
    const [gg1ExportParams, setGG1ExportParams] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");


    const { postingResult, loading } = useSelector(
        (state) => state.JobAnnouncementReducer
    );

    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    const [sortedColumns, setSortedColumns] = useState(visileColumns);

    // const [sortedColumns, setSortedColumns] = useSortedColumns(
    //     id,
    //     ColumnsSorted,
    //     [],
    //     visileColumns,
    //     userData
    // );

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    return (
        <ErrorBoundary>
            <Fragment>
                <Container fluid={true}>
                    <Row>
                        <Col sm="12" className="page-content">
                            <Card>
                                {/* <CardHeader>
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <h5 className="m-0">All Applicants List</h5>
                                        </div>
                                    </div>
                                </CardHeader> */}
                                <CardBody>
                                    <div>
                                        <TelerikDataTable
                                            id={id}
                                            pageNumber={page}
                                            pageSize={pageSize}
                                            totalCount={rowCount}
                                            skip={(page - 1) * pageSize}
                                            take={pageSize}
                                            data={results.map((item)=>({...item, evaluation_rating: item?.evaluation_rating?.toFixed(2)??0})) || []}
                                            sortData={sortData}
                                            tableName={"applicant-by-annountment-eligiblity"}
                                            searchParams={searchParams}
                                            additionalWhere={additionalWhere}
                                            onFilterChange={handleFilterChange}
                                            onSortChange={handleSortChange}
                                            onPageChange={handlePageChange}
                                            onPageSizeChange={handlePageSizeChange}
                                            selectedColumns={sortedColumns}
                                            setSortedColumns={setSortedColumns}
                                            loading={loadingSearch}
                                            enableFooterCell={false}
                                            dataLocation="pmis-global"
                                            // setChooseFilterMethod={setChooseFilterMethod}
                                            // actions={actions}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        </ErrorBoundary>
    );
}

export default ApplicantsListByEligibility;
